import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import { EditLotteryMutation as EditLottery, EditLotteryInput } from '__generated__/graphql';

import { useNotifier } from '../../../common/Notifications/NotificationProvider';
import EditLotteryMutation from './EditLotteryMutation';
import useScroll from '../../../common/useScroll';

interface UseEditLotteryMutationProps {
  input: EditLotteryInput,
  onSuccess?: (ticket: EditLottery['editLottery']) => void;
}

const useEditLotteryMutation = ({
  input, onSuccess,
}: UseEditLotteryMutationProps) => {
  const { t } = useTranslation();
  const notifier = useNotifier();
  const { scrollToIfInvisible } = useScroll();

  return useMutation(
    EditLotteryMutation,
    {
      variables: {
        input,
      },
      onCompleted: ({ editLottery: lottery }) => {
        notifier.success(t('notifications.lottery_saved'));

        onSuccess?.(lottery);
      },
      onError: () => {
        scrollToIfInvisible(`LotteryCard_${input.id}`);
      },
    },
  );
};

export default useEditLotteryMutation;
